module.exports = "<div class=\"timer\">\n  <span id=\"seconds\"> {{secondsToCount}} </span>s\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-countdown/bra-countdown.component.html
// module id = ../../../../../src/app/componentes/bra-countdown/bra-countdown.component.html
// module chunks = main